import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
// noinspection DuplicatedCode

import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseableDialog from "./CloseableDialog";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import CloseIcon from "@material-ui/icons/Close";
import * as SessionInfo from "../../SessionInfo";
import { useSessionInfo } from "../../SessionInfo";
import TextField from "@material-ui/core/TextField";
import * as Utils from "../../Utils";
import { makeStyles } from "@material-ui/core/styles";
import { FormHelperText } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import DownloadIcon from "@material-ui/icons/GetApp";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      flexGrow: 1,
      "& .MuiTypography-root": {
        marginBottom: theme.spacing(1)
      }
    },
    textField: {
      backgroundColor: "#FBFBFB",
      minWidth: "50%",
      borderRadius: theme.shape.borderRadius
    },
    redTextFieldInput: {
      color: "red"
    },
    greenTextFieldInput: {
      color: "green"
    },
    input: {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius
    }
  };
});
var ManageOfflineLicenseDialog = function ManageOfflineLicenseDialog(_ref) {
  var open = _ref.open,
    handleClose = _ref.handleClose;
  console.log("ManageOfflineLicenseDialog");
  var classes = useStyles();
  var _useSessionInfo = useSessionInfo(),
    _useSessionInfo2 = _slicedToArray(_useSessionInfo, 1),
    sessionInfo = _useSessionInfo2[0];
  var _useState = useState({
      applicationCanRun: false,
      applicationCanRunStr: '',
      licenseValid: false,
      licenseActivated: false,
      hasTransactionReader: false,
      licenseNeedsActivation: false,
      productName: '',
      licenseNumber: '',
      licenseActivationCode: '',
      licenseIssuedDate: null,
      licenseExpirationDate: null,
      licenseIssuedDateStr: '',
      licenseExpirationDateStr: '',
      remainingPoints: null,
      remainingPointsStr: '',
      softwareVersion: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    licenseInfo = _useState2[0],
    setLicenseInfo = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var userLicensed = sessionInfo && sessionInfo.props && sessionInfo.props.licensed;
  var applicationLicensed = sessionInfo && sessionInfo.props && sessionInfo.props.applicationLicensed;
  var showManageOfflineLicenseDialog = sessionInfo && sessionInfo.props && sessionInfo.props.showManageOfflineLicenseDialog;
  var dialogOpen = open || showManageOfflineLicenseDialog;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    licenseFileUploadPending = _React$useState2[0],
    setLicenseFileUploadPending = _React$useState2[1];
  var uploadLicenseFileButtonClick = function uploadLicenseFileButtonClick() {
    var fileSelect = document.getElementById("contained-button-file");
    fileSelect.click();
  };

  /**
   * Executed when the user actually picks a SAML assertion token file. This is what uploads it
   *  to the server.
   */
  var uploadLicenseFileAfterSelection = function uploadLicenseFileAfterSelection(e) {
    var fileSelect = document.getElementById("contained-button-file");
    var selectedFile = fileSelect.files[0];

    // The token can only be uploaded to the Cloud API URL
    uploadLicenseFile(selectedFile, "configuration/license/uploadLicense");
  };
  var uploadLicenseFile = function uploadLicenseFile(file, uri) {
    console.log("Submitting file [" + file + "] to URL [" + uri + "]");
    setLicenseFileUploadPending(true);
    var data = new FormData();
    data.append("file", file);
    Utils.fetchData(uri, {
      method: "POST",
      body: data
    }, false, true).then(function (licenseInformation) {
      setLicenseFileUploadPending(false);
      setLicenseInfo(licenseInformation);
      if (!licenseInformation.licenseValid) {
        setErrorMessage("License is still invalid");
      } else {
        setErrorMessage(null);
      }
    }).catch(function (error) {
      Utils.getErrorMessage(error, "Upload license failed.").then(setErrorMessage);
    });
  };
  React.useEffect(function () {
    Utils.fetchData("configuration/license/licenseInformation", null, false, true).then(function (data) {
      setLicenseInfo(data);
    }).catch(function (error) {
      Utils.getErrorMessage(error, "Retrieve license info failed.").then(setErrorMessage);
    });
  }, []);
  var onClose = function onClose() {
    if (userLicensed && applicationLicensed) {
      handleClose();
    } else {
      // Logout
      SessionInfo.clear();
    }
  };
  var booleanToText = function booleanToText(booleanValue) {
    if (booleanValue) {
      return "Yes";
    } else {
      return "No";
    }
  };
  if (!sessionInfo) {
    return null;
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CloseableDialog, {
      fullWidth: true,
      open: dialogOpen,
      title: "Offline License Management",
      maxWidth: "md",
      handleClose: onClose,
      closeIcon: userLicensed ? /*#__PURE__*/React.createElement(CloseIcon, null) : /*#__PURE__*/React.createElement(LogoutIcon, null)
    }, /*#__PURE__*/React.createElement(DialogContent, {
      dividers: true
    }, /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errorMessage), /*#__PURE__*/React.createElement("h6", {
      style: {
        marginTop: "15px"
      }
    }, "License Information"), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "Application Can Run",
      readOnly: true,
      inputProps: {
        className: licenseInfo.applicationCanRun ? classes.greenTextFieldInput : classes.redTextFieldInput
      },
      helperText: "Validates if the license is valid and activated - if those conditions are not true, the application cannot run",
      value: licenseInfo.applicationCanRunStr
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "License Valid",
      readOnly: true,
      value: booleanToText(licenseInfo.licenseValid)
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "License Issued Date",
      readOnly: true,
      value: licenseInfo.licenseIssuedDateStr
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "License Expiration Date",
      readOnly: true,
      value: licenseInfo.licenseExpirationDateStr
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "Points Included with License",
      readOnly: true,
      value: licenseInfo.remainingPointsStr
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "Software Version",
      readOnly: true,
      value: licenseInfo.softwareVersion
    }), /*#__PURE__*/React.createElement("h6", {
      style: {
        marginTop: "15px"
      }
    }, "License Activation"), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "License Activated",
      readOnly: true,
      value: booleanToText(licenseInfo.licenseActivated)
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "Product Name",
      readOnly: true,
      value: licenseInfo.productName
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "License Number",
      readOnly: true,
      value: licenseInfo.licenseNumber
    }), /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      className: classes.textField,
      label: "License Activation Code",
      readOnly: true,
      value: licenseInfo.licenseActivationCode
    }), licenseInfo.licenseNeedsActivation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "This license needs activation. You can select this text and use it to send the activation information to Emerald Associates."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "License activation code: ", licenseInfo.licenseActivationCode, ", license number: ", licenseInfo.licenseNumber, ", product name: ", licenseInfo.productName, ".")), /*#__PURE__*/React.createElement("h6", {
      style: {
        marginTop: "15px"
      }
    }, "Upload License"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "Use this button to upload a new license to the application, or an activated license. ", /*#__PURE__*/React.createElement("b", null, "After uploading the license"), ", please refresh the browser to reload the application."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: ".license",
      style: {
        display: 'none'
      },
      onChange: uploadLicenseFileAfterSelection,
      id: "contained-button-file"
    }), /*#__PURE__*/React.createElement(Button, {
      style: {
        width: 200,
        marginTop: 15
      },
      type: "submit",
      variant: "contained",
      color: "primary",
      className: classes.submit,
      onClick: uploadLicenseFileButtonClick,
      disabled: licenseFileUploadPending
    }, "Upload License File", licenseFileUploadPending && /*#__PURE__*/React.createElement(CircularProgress, {
      color: "inherit",
      style: {
        marginLeft: "10px"
      },
      size: 20
    })), /*#__PURE__*/React.createElement("h6", {
      style: {
        marginTop: "15px"
      }
    }, "Transaction Log"), licenseInfo.hasTransactionReader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "This installation supports a transaction reader. Please use the button below to download the transactions from this application. Afterwards, please go to ", /*#__PURE__*/React.createElement("a", {
      href: "https://licensing.emerald-associates.com/licensing-admin",
      target: "_blank"
    }, "licensing admin"), " to upload this license."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Link, {
      download: "transaction-log.txt",
      href: Utils.getBaseUrl() + "configuration/license/downloadTransactionLog"
    }, /*#__PURE__*/React.createElement(Button, {
      style: {
        width: 200,
        marginTop: 15
      },
      variant: "contained",
      color: "primary",
      className: classes.submit,
      startIcon: /*#__PURE__*/React.createElement(DownloadIcon, null)
    }, "Download"))), !licenseInfo.hasTransactionReader && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, "This application does not contain a transaction reader. The transaction log cannot be download."))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      onClick: onClose
    }, "Close"))));
  }
};
export default ManageOfflineLicenseDialog;